import { render } from "./CenteredContent.vue?vue&type=template&id=18fbbd3e"
import script from "./CenteredContent.vue?vue&type=script&lang=js"
export * from "./CenteredContent.vue?vue&type=script&lang=js"
script.render = render

export default script